export enum UserTypeEnum {
  Admin = 1,
  Employee = 2,
  Editor = 3,
}
